import img1 from "../../assets/service/3d_icon.png";
import img2 from "../../assets/service/laser_icon.png";
import img3 from "../../assets/service/pcb_icon.png";

const landingData = [
  {
    name: "3D Printing",
    image: img1,
    price: "6",
    unit: "/gram",
    data: [
      "Layer Height: 0.1mm -0.8mm",
      <>
        Print volume: 300mm x 300mm <br /> x 400mm (max), 230mm x 230mm x <br />{" "}
        300mm(regular)
      </>,
      "Color: single color. Two color is also possible",
    ],
    text: "Build Time: 1 Day",
  },
  {
    name: "Laser Cutting",
    image: img2,
    price: "18",
    unit: "/minute",
    data: ["Plywood", "PVC", "Acrylic ", "Wood ", "Leather "],
    text: "Build Time: 1 Day",
  },
  {
    name: "PCB Manufacturing",
    image: img3,
    price: "5",
    unit: "/sq-/inch",
    data: [
      "Single and double layer",
      "Maximum size: A4(210mm x 297mm)",
      <>Minimum trace width: 	15mill <br/>(0.381mm)</>,
      "File type : PDF, Gerber"
    ],
    text: "Build Time: 1 Day",
    unavailable: true
  },
];

export default landingData;
